module.exports = __webpack_public_path__ + "images/25015-INT-S1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/25015-INT-S1.jpg
// module id = 20
// module chunks = 0